import styled from "styled-components";
import { StandardScrollBarStyle } from "@themes/GlobalStyles";

export const Container = styled.section`
  width: 560px;
  border-radius: 20px;
  background-color: var(--hv-surface-popup);
  border: 1px solid var(--hv-border-default);
  box-shadow: var(--hv-shadow-4);

  .react-grid-item {
    &.react-grid-placeholder {
      border-radius: 8px;
      /* [TODO] : change to the Color/Dark/Brand/B 4 ( if the color is supprted in HV Color Theme) */
      background-color: #f3732161;
      opacity: 1;
    }
  }

  .react-grid-layout {
    margin: 0 4px;
    ${StandardScrollBarStyle}
  }
`;

export const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 28px 32px 20px;
`;

export const Title = styled.h1`
  font-size: 20px;
  color: var(--hv-text-normal-primary);
  font-weight: 600;
`;

export const ListItem = styled.li`
  width: 496px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin: 24px 32px;
`;
